module.exports = __webpack_public_path__ + "fonts/poppins-italic-webfont.5684fc53.woff";